import React, { useEffect } from "react";

export default function ConfirmDeleteModal({ open, usuario, onClose, onConfirm, deleting }) {
  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    if (open) document.body.classList.add("modal-open");
    else document.body.classList.remove("modal-open");
    return () => document.body.classList.remove("modal-open");
  }, [open]);

  if (!open) return null;

  return (
    <div className="modal fade show d-block management-modal usuarios-modal" tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header border-0">
            <div>
              <p className="dashboard-eyebrow mb-1 text-danger">Eliminar registro</p>
              <h5 className="modal-title mb-0 d-flex align-items-center gap-2">
                <i className="bi bi-exclamation-triangle" />
                Confirmar accion
              </h5>
            </div>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>
          <div className="modal-body">
            <p className="mb-2">
              Deseas eliminar al usuario <strong>{usuario?.nombre_completo}</strong>?
            </p>
            <p className="text-muted mb-0">
              Esta accion lo marcara como inactivo y no aparecera mas en los listados.
            </p>
          </div>
          <div className="modal-footer border-0 pt-0">
            <button type="button" className="btn btn-outline-secondary" onClick={onClose}>
              Cancelar
            </button>
            <button type="button" className="btn btn-danger text-white" onClick={onConfirm} disabled={deleting}>
              {deleting ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" />
                  Eliminando...
                </>
              ) : (
                "Eliminar"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

